import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
  },
  marketingConsentsPointsInfo: {
    marginRight: '4px',
  },
});

const AdditionalInfoLabel = ({ children, tooltipTitle, tooltipLink }) => {
  const classes = useStyles();

  return (
    <span className={classes.wrapper}>
      <span className={classes.marketingConsentsPointsInfo}>{children}</span>
      <InfoWithTooltip title={tooltipTitle} link={tooltipLink} />
    </span>
  );
};

export default AdditionalInfoLabel;
